export default __webpack_public_path__ + "static/media/ideas.07cd6a8e.png";